<template>
  <modal
    v-if="videoette"
    @leave="leave()"
  >
    <button class="absolute pin-r pin-t m-2 cursor-pointer" @click="leave()">
      <i class="fas fa-times fa-fw"></i>
    </button>
    <div class="flex flex-col items-start">
      <h2 class="text-2xl font-medium">
        Cancel Videoette
      </h2>
      <h3 class="mt-1 text-lg font-normal">
        {{ videoette.display_address }}
      </h3>
      <div class="mt-4 w-full flex justify-end flex-wrap">
        <div class="w-full xl:w-2/3 text-left">
          <input
            type="text"
            class="input w-full"
            v-model="reason"
          >
          <small class="block xl:hidden mt-1 text-sm text-grey">
            Please provide a brief reason for cancelling this videoette
          </small>
        </div>
        <button
          class="xl:ml-6 py-3 px-6 bg-secondary rounded mt-2 xl:mt-0 xl:flex-grow"
          @click="exclude()"
          :disabled="loading"
        >
          {{ loading ? 'Cancelling...' : 'Cancel' }}
        </button>
      </div>
      <small class="hidden xl:block mt-1 text-sm text-grey">
        Please provide a brief reason for cancelling this videoette
      </small>
    </div>
  </modal>
</template>

<script>
import api from '@/http'
import { mapActions } from 'vuex'

export default {
  name: 'exclude-videoette',

  props: ['videoette'],

  data () {
    return {
      loading: false,
      reason: null
    }
  },

  methods: {
    ...mapActions(['displayToastNotification']),

    exclude () {
      this.loading = true

      api
        .patch(`/videoettes/exclude/${this.videoette.id}`, {
          reason: this.reason
        })
        .then(() => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Videoette cancelled',
            info: 'Your videoette has been successfully cancelled.'
          })

          this.videoette.status = 'Cancelled'
          this.loading = false
          this.leave()
        })
        .catch(({ response }) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation',
            title: 'Failed to cancel videoette',
            info: response.status >= 500
              ? 'We\'re unable to cancel your videoette at this time.'
              : response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    leave () {
      if (this.loading) return

      this.$emit('leave')
    }
  }
}
</script>
